import { render, staticRenderFns } from "./CheckBlock.vue?vue&type=template&id=db0bff98"
import script from "./CheckBlock.vue?vue&type=script&lang=js"
export * from "./CheckBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports